import { createModelPage } from '../utils'

import Create from './pages/Create'
import Update from './pages/Update'
import List from './pages/List'
import View from './pages/View'
import Delete from './pages/Delete'

export default createModelPage<any, any>({
  name: 'Course Chapters',
  index: List,
  view: View,
  create: Create,
  edit: Update,
  destroy: Delete,
})
